import React, { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';

const RejectVoucherModal = ({ show, voucher, onConfirm, onHide, loading }) => {
  const [reason, setReason] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (show) {
      setReason('');
      setError('');
    }
  }, [show]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmed = reason.trim();
    if (!trimmed) {
      setError('Vui lòng nhập lý do từ chối');
      return;
    }
    setError('');
    onConfirm(trimmed);
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>Từ chối phiếu chi</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {voucher && (
            <p className="text-muted small mb-3">
              Phiếu <strong>{voucher.voucherNumber || voucher.id}</strong> —{' '}
              {new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND', maximumFractionDigits: 0 }).format(
                Number(voucher.amount || 0),
              )}
            </p>
          )}
          <Form.Group>
            <Form.Label>Lý do từ chối *</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="Nhập lý do từ chối cụ thể..."
              value={reason}
              onChange={(e) => { setReason(e.target.value); setError(''); }}
              isInvalid={!!error}
              autoFocus
            />
            <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide} disabled={loading}>
            Hủy
          </Button>
          <Button type="submit" variant="warning" disabled={loading}>
            {loading ? 'Đang xử lý...' : 'Xác nhận từ chối'}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default RejectVoucherModal;
